import { useEffect, useState } from "react";
import axios from "axios";

const API = "/api";

type Mensaje = { texto: string; ok: boolean } | null;

export default function SegundoCatalogo() {
  const [cfg, setCfg] = useState({ url: "", texto_boton: "", activo: true });
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [probando, setProbando] = useState(false);
  const [msg, setMsg] = useState<Mensaje>(null);
  const [msgPrueba, setMsgPrueba] = useState<Mensaje>(null);

  const token = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + token };

  useEffect(() => {
    axios.get(API + "/catalogo2/admin", { headers })
      .then((r) => setCfg({
        url: r.data.url || "",
        texto_boton: r.data.texto_boton || "",
        activo: r.data.activo ?? true,
      }))
      .catch(() => setMsg({ texto: "No se pudo cargar la configuración", ok: false }))
      .finally(() => setCargando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const guardar = async () => {
    setGuardando(true);
    setMsg(null);
    try {
      const r = await axios.put(API + "/catalogo2/admin", cfg, { headers });
      setCfg({ url: r.data.url, texto_boton: r.data.texto_boton, activo: r.data.activo });
      setMsg({ texto: "Guardado correctamente", ok: true });
      setTimeout(() => setMsg(null), 3000);
    } catch (e: any) {
      const detalle = e?.response?.data?.detail;
      setMsg({ texto: typeof detalle === "string" ? detalle : "Error al guardar", ok: false });
    }
    setGuardando(false);
  };

  const probar = async () => {
    setProbando(true);
    setMsgPrueba(null);
    try {
      const r = await axios.post(API + "/catalogo2/admin/probar", { url: cfg.url }, { headers });
      setMsgPrueba(r.data.disponible
        ? { texto: "El enlace responde correctamente", ok: true }
        : { texto: "El enlace no responde (" + r.data.motivo + ")", ok: false });
    } catch (e: any) {
      const detalle = e?.response?.data?.detail;
      setMsgPrueba({ texto: typeof detalle === "string" ? detalle : "No se pudo probar el enlace", ok: false });
    }
    setProbando(false);
  };

  const card: React.CSSProperties = { background: "#fff", borderRadius: "16px", padding: "28px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)", marginBottom: "24px" };
  const label: React.CSSProperties = { display: "block", fontSize: "13px", fontWeight: 700, color: "#374151", marginBottom: "6px" };
  const input: React.CSSProperties = { width: "100%", border: "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", fontSize: "14px", fontFamily: "Nunito,sans-serif", boxSizing: "border-box", outline: "none" };
  const boton = (fondo: string, color: string, deshabilitado: boolean): React.CSSProperties => ({
    background: fondo, color, border: "none", borderRadius: "10px", padding: "12px 24px",
    fontWeight: 800, fontSize: "14px", fontFamily: "Montserrat,sans-serif",
    cursor: deshabilitado ? "not-allowed" : "pointer", opacity: deshabilitado ? 0.6 : 1,
  });
  const aviso = (m: Mensaje): React.CSSProperties => ({
    fontSize: "13px", fontWeight: 700, color: m?.ok ? "#15803d" : "#b91c1c", marginTop: "10px",
  });

  const vistaPrevia = cfg.texto_boton.trim() || "📘 Catálogo Grupo Castro";

  return (
    <div>
      <div style={{ marginBottom: "28px" }}>
        <h1 style={{ fontFamily: "Montserrat,sans-serif", fontSize: "24px", fontWeight: 900, color: "#0D47A1", margin: 0 }}>Segundo catálogo</h1>
        <p style={{ color: "#6b7280", marginTop: "6px", fontSize: "14px" }}>
          Botón de la página de inicio que lleva al catálogo de otro proveedor
        </p>
      </div>

      <div style={card}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
          <span style={{ fontSize: "24px" }}>📘</span>
          <div>
            <h2 style={{ fontFamily: "Montserrat,sans-serif", fontWeight: 800, fontSize: "16px", margin: 0 }}>Enlace y texto del botón</h2>
            <p style={{ color: "#6b7280", fontSize: "13px", margin: "2px 0 0" }}>
              Si el enlace deja de funcionar, los clientes verán un aviso de actualización con el WhatsApp.
            </p>
          </div>
        </div>

        <div style={{ background: "linear-gradient(135deg,#1565C0,#0D47A1)", borderRadius: "10px", padding: "18px 20px", marginBottom: "20px", textAlign: "center" }}>
          <span style={{ display: "inline-block", background: "#fff", color: "#1565C0", padding: "12px 28px", borderRadius: "50px", fontWeight: 800, fontSize: "15px", fontFamily: "Nunito,sans-serif" }}>
            {vistaPrevia}
          </span>
        </div>

        {cargando ? (
          <p style={{ color: "#6b7280", fontSize: "14px" }}>Cargando…</p>
        ) : (
          <>
            <label style={label}>Enlace del catálogo</label>
            <input type="url" value={cfg.url} onChange={(e) => { setCfg({ ...cfg, url: e.target.value }); setMsgPrueba(null); }}
              placeholder="https://www.grupocastrocr.com" style={input} />
            <p style={{ color: "#6b7280", fontSize: "12px", margin: "6px 0 0" }}>
              Debe empezar con https://. Si lo dejas vacío, el botón se oculta de la página.
            </p>
            <div style={{ marginTop: "12px" }}>
              <button onClick={probar} disabled={probando || !cfg.url.trim()} style={boton("#e5e7eb", "#374151", probando || !cfg.url.trim())}>
                {probando ? "Probando…" : "Probar enlace"}
              </button>
              {msgPrueba && <div style={aviso(msgPrueba)}>{msgPrueba.texto}</div>}
            </div>

            <label style={{ ...label, marginTop: "22px" }}>Texto del botón</label>
            <input type="text" value={cfg.texto_boton} maxLength={80} onChange={(e) => setCfg({ ...cfg, texto_boton: e.target.value })}
              placeholder="📘 Catálogo Grupo Castro" style={input} />

            <label style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginTop: "22px", cursor: "pointer" }}>
              <input type="checkbox" checked={cfg.activo} onChange={(e) => setCfg({ ...cfg, activo: e.target.checked })}
                style={{ width: "18px", height: "18px", marginTop: "2px" }} />
              <span style={{ fontSize: "14px", color: "#374151" }}>
                <strong>Catálogo disponible</strong><br />
                <span style={{ color: "#6b7280", fontSize: "13px" }}>
                  Desmárcalo para mostrar el aviso "Estamos actualizando el segundo catálogo" aunque el enlace funcione.
                </span>
              </span>
            </label>

            <div style={{ marginTop: "26px" }}>
              <button onClick={guardar} disabled={guardando} style={boton("#1565C0", "#fff", guardando)}>
                {guardando ? "Guardando…" : "Guardar cambios"}
              </button>
              {msg && <div style={aviso(msg)}>{msg.texto}</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
